module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_6.cd9e7937.png";